module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.5dff34d.woff";